"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const accordionTabs = {
    isMobile() {
        return window.innerWidth < 1056;
    },
    init(el) {
        //get hash from url
        const hash = window.location.hash;
        // if hash exists
        if (hash) {
            const tab = el.querySelector(hash);
            //if tab with hash id exists, open it and scroll to it
            if (tab) {
                this.closeAllTabs(el);
                //set tab to open
                tab.setAttribute('open', 'true');
                this.scrollToTab(tab);
            }
        }
        // Edge doesn't show display: contents as expected, display as accordion
        if (!/MSIE|Trident/.test(window.navigator.userAgent)) {
            el.classList.add('accordion-tabs--initialized');
        }
        else {
            return;
        }
        if (el.classList.contains('accordion-tabs')) {
            const tabs = el.querySelectorAll('details');
            tabs?.forEach((tab) => {
                const summary = tab.querySelector('summary');
                summary?.addEventListener('click', (e) => {
                    // Tabs view is only on screens md and up
                    if (!this.isMobile()) {
                        if (tab.hasAttribute('open')) {
                            e.preventDefault();
                        }
                        else {
                            this.closeAllTabs(el);
                            //this.scrollToTab(tab as HTMLElement);
                        }
                    }
                });
            });
        }
    },
    closeAllTabs(el) {
        const tabs = el?.querySelectorAll('details');
        tabs?.forEach((tab) => {
            tab.removeAttribute('open');
        });
    },
    scrollToTab(tab) {
        const content = tab.querySelector('.accordion__header'); //we get header to prevent it from being hidden by the fixed header
        if (content) {
            //get content absolute position and scroll window to it
            const contentPosition = content.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: contentPosition - 100,
                behavior: 'smooth'
            });
        }
    }
};
exports.default = accordionTabs;
